import { render, staticRenderFns } from "./SubmitTestTableSP.vue?vue&type=template&id=6bdc2016&scoped=true&"
import script from "./SubmitTestTableSP.vue?vue&type=script&lang=ts&"
export * from "./SubmitTestTableSP.vue?vue&type=script&lang=ts&"
import style0 from "./SubmitTestTableSP.vue?vue&type=style&index=0&id=6bdc2016&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdc2016",
  null
  
)

export default component.exports